"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.block = exports.blockPage = void 0;
var React = require("react");
var PlaceAvailable_1 = require("@/pages/place/components/PlaceAvailable");
var PlaceSimilar_1 = require("@/pages/place/components/PlaceSimilar");
var Place_1 = require("@/pages/place/components/Place");
var PlaceCards_1 = require("@/pages/place/components/PlaceCards");
var PlaceFollowPopup_1 = require("@/pages/place/components/PlaceFollowPopup");
var BlockTop_1 = require("@/pages/place/components/BlockTop");
var PlaceListYourProperty_1 = require("@/pages/place/components/PlaceListYourProperty");
var PlaceChart_1 = require("@/pages/place/components/PlaceChart");
var PlaceTransaction_1 = require("@/pages/place/components/PlaceTransaction");
exports.blockPage = function (props) {
    var bgColor = (!props.availablePropertiesRent.length && !props.availablePropertiesSale.length) ? '#f9f9f9' : 'transparent';
    return (React.createElement(React.Fragment, null,
        React.createElement(PlaceChart_1.default, { hidden: !props.showChart }),
        React.createElement(PlaceTransaction_1.default, { hidden: !props.showTransaction, title: props.name }),
        React.createElement("div", { style: { backgroundColor: bgColor } },
            React.createElement(PlaceAvailable_1.placeAvailable, __assign({}, props))),
        React.createElement(PlaceListYourProperty_1.PlaceListYourProperty, __assign({}, props)),
        React.createElement(PlaceCards_1.placeCards, __assign({}, props)),
        React.createElement(PlaceSimilar_1.placeSimilar, __assign({}, props)),
        React.createElement(PlaceFollowPopup_1.placeFollowPopup, __assign({}, props))));
};
exports.block = Place_1.withPlaceTemplate(exports.blockPage, BlockTop_1.blockTopSection);
exports.default = exports.block;
